import { useNavigationBlockerViaHistory, useOnline, useTriggerAction } from '@libs/hooks';
import { isShowChallenge, selectRootWidgetUids, useAppDispatch, useAppSelector, useSystemAction } from '@libs/store';
import { ActionSystemActionType, SystemEventTypeEnum, TCommonData, TWidget } from '@libs/types';
import { ConditionalRender, eventBus } from '@libs/utils';
import React, { useLayoutEffect } from 'react';
import Widget from '../widgets/Widget';
import { makeWidgetsList } from '../widgets/WidgetsList';
import { Challenge, Offline, PortalWrapper, Provider, WidgetWrapper } from './index';

const WidgetsList = makeWidgetsList(Widget);

export function App() {
    const rootWidgetUids = useAppSelector(selectRootWidgetUids);
    const statusShowChallenge = useAppSelector(isShowChallenge);
    const dispatch = useAppDispatch();
    const isOnline = useOnline();
    const { triggerAction } = useTriggerAction({} as TWidget<TCommonData>, true);
    const systemActionNavigateBack = useSystemAction(ActionSystemActionType.navigateBack);
    useNavigationBlockerViaHistory(true, { triggerAction, systemActionNavigateBack });

    useLayoutEffect(() => {
        let documentScrolled = false;
        const handleScroll = () => {
            const scrolled = window?.scrollY !== 0;
            if (documentScrolled !== scrolled) {
                documentScrolled = scrolled;
                eventBus.emitGeneral(SystemEventTypeEnum.SCROLLED, scrolled);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [dispatch]);

    return (
        <Provider>
            <Offline />
            <Challenge />
            <ConditionalRender condition={isOnline && !statusShowChallenge}>
                <WidgetWrapper>
                    <PortalWrapper>
                        <WidgetsList uids={rootWidgetUids} />
                    </PortalWrapper>
                </WidgetWrapper>
            </ConditionalRender>
        </Provider>
    );
}
